import { BtnSwitchComponent, DateFormatPipe, FormControlFeedbackComponent, ListPagingComponent, LoaderSpinnerComponent, MultiSelectComponent, PageHeaderComponent } from '@aston/foundation';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgbAlertModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { FileUploadComponent } from '../shared-module/components/file-upload/file-upload.component';
import { FileUploadInstructionsComponent } from '../shared-module/components/file-upload-instructions/file-upload-instructions.component';
import { LayoutBaseComponent } from '../shared-module/layouts/layout-base/layout-base.component';
import { TopBarComponent } from '../shared-module/components/top-bar/top-bar.component';

import { HasFederationsGuard, FederationAdminGuard } from './guards';
import { FederationsService } from './services';
import { FederationFormPageComponent } from './pages/federation-form-page/federation-form-page.component';
import { NewFederationStepsComponent } from './components/new-federation-steps/new-federation-steps.component';
import { NewFederationLayoutComponent } from './layouts/new-federation-layout/new-federation-layout.component';
import { FederationsMenuLayoutComponent } from './layouts/federations-menu-layout/federations-menu-layout.component';
import { MenuLinksComponent } from './components/menu-links/menu-links.component';
import { FederationFormComponent } from './components/federation-form/federation-form.component';
import { FederationValidationPageComponent } from './pages/federation-validation-page/federation-validation-page.component';
import { FederationsListComponent } from './components/federations-list/federations-list.component';
import { FederationUserCreateFormComponent } from './components/federation-user-create-form/federation-user-create-form.component';
import { FederationUsersListTableComponent } from './components/federation-users-list-table/federation-users-list-table.component';
import { FederationDetailUsersPageComponent } from './pages/federation-detail-users-page/federation-detail-users-page.component';



@NgModule({
	exports: [
		FederationsListComponent,
	],
	imports: [
		BrowserAnimationsModule,
		BtnSwitchComponent,
		CommonModule,
		DateFormatPipe,
		FederationsListComponent,
		FederationUserCreateFormComponent,
		FileUploadComponent,
		FileUploadInstructionsComponent,
		FormControlFeedbackComponent,
		FormsModule,
		LayoutBaseComponent,
		ListPagingComponent,
		LoaderSpinnerComponent,
		MultiSelectComponent,
		NgbAlertModule,
		NgbDropdownModule,
		NgbTooltipModule,
		NgSelectModule,
		PageHeaderComponent,
		ReactiveFormsModule,
		RouterModule,
		TooltipModule,
		TopBarComponent,
		TranslateModule,
		FederationDetailUsersPageComponent,
		FederationFormComponent,
		FederationFormPageComponent,
		FederationsMenuLayoutComponent,
		FederationUsersListTableComponent,
		FederationValidationPageComponent,
		MenuLinksComponent,
		NewFederationLayoutComponent,
		NewFederationStepsComponent,
	],
	providers: [
		FederationAdminGuard,
		FederationsService,
		HasFederationsGuard,
	]
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class FederationsModule { }

